/* @flow */
/* global Number */
import Masked from 'vanilla-masker';

export default function Money(value, noCurrency, formatter) {
  const moneyFormatter = {
    precision: 2,
    separator: ',',
    delimiter: '.',
    unit: 'R$',
    ...formatter,
  };
  if (noCurrency === true) {
    moneyFormatter.unit = '';
  }
  if (value) {
    const number = Number.isNaN(value) ? value : typeof value === 'string' ? value : value.toFixed(2);
    return Masked.toMoney(number, moneyFormatter);
  }
  return Masked.toMoney('0.00', moneyFormatter);
}
